<template>
  <div class="d-flex flex-column w-100">
    <!-- TITLE -->
    <div class="d-flex flex-row text-body-medium pb-1 rounded-0">
      {{ i18n.t('titles.approved_as') }}
    </div>
    <!-- /TITLE -->

    <div class="d-flex align-center justify-space-between">
      <div>
        <!-- APPROVERS  DETAILS -->
        <SignerSignDetails :email="email" :show-signature-level="false" />
        <!-- /APPROVERS  DETAILS -->
        <div class="d-flex align-center justify-center ga-1 mt-1">
          <span class="text-body-medium text-green-darken-1">
            {{ i18n.t('document_status.approved') }}:
          </span>
          <div v-if="completionTime" class="d-flex align-center">
            <span class="text-grey text-body-medium">
              {{ formatDateToLocale(completionTime, i18n.locale.value, true) }}
            </span>
          </div>
          <v-spacer />
        </div>
      </div>
      <v-icon
        v-if="
          signStore.document?.signContext.signStatus === SignStatus.APPROVED
        "
        color="success"
        size="18"
      >
        fas fa-circle-check
      </v-icon>
    </div>
  </div>
</template>
<script lang="ts" setup>
import SignerSignDetails from '@/components/signatureArea/SignerSignDetails.vue';
import { useI18n } from 'vue-i18n';
import { computed } from 'vue';
import { useSignStore } from '@/stores/sign.ts';
import { formatDateToLocale } from '@/composables/useUtils.ts';
import { SignStatus } from '@/types/enums/SignStatus.ts';

const i18n = useI18n();
const signStore = useSignStore();
const email = computed(() => signStore.document?.signContext.email);
const completionTime = computed(
  () => signStore.document?.signContext?.completionTime
);
</script>
